import { render } from "./ChangePassword.vue?vue&type=template&id=4fb0c12f"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\dev\\Lipa-Digital-Labs\\dev\\Potsmunter\\mpt-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__